// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/bet_type.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/bet_type.proto.
 */
export const file_v1_bet_type: GenFile = /*@__PURE__*/
  fileDesc("ChF2MS9iZXRfdHlwZS5wcm90bxICdjEiFQoTTGlzdEJldFR5cGVzUmVxdWVzdCI2ChRMaXN0QmV0VHlwZXNSZXNwb25zZRIeCgliZXRfdHlwZXMYASADKAsyCy52MS5CZXRUeXBlIhkKCFR5cGVMaXN0Eg0KBXR5cGVzGAEgAygJIoUBChVVcGRhdGVCZXRUeXBlc1JlcXVlc3QSMQoEZGF0YRgBIAMoCzIjLnYxLlVwZGF0ZUJldFR5cGVzUmVxdWVzdC5EYXRhRW50cnkaOQoJRGF0YUVudHJ5EgsKA2tleRgBIAEoBRIbCgV2YWx1ZRgCIAEoCzIMLnYxLlR5cGVMaXN0OgI4ASJKCgdCZXRUeXBlEgoKAmlkGAEgASgFEhMKC2JldF90eXBlX2lkGAIgASgFEgwKBHR5cGUYAyABKAkSEAoIdXNlcm5hbWUYBCABKAkiWgoWVXBkYXRlQmV0VHlwZXNSZXNwb25zZRIeCgliZXRfdHlwZXMYASADKAsyCy52MS5CZXRUeXBlEg8KB3N1Y2Nlc3MYAiABKAgSDwoHbWVzc2FnZRgDIAEoCTKgAQoOQmV0VHlwZVNlcnZpY2USQwoMTGlzdEJldFR5cGVzEhcudjEuTGlzdEJldFR5cGVzUmVxdWVzdBoYLnYxLkxpc3RCZXRUeXBlc1Jlc3BvbnNlIgASSQoOVXBkYXRlQmV0VHlwZXMSGS52MS5VcGRhdGVCZXRUeXBlc1JlcXVlc3QaGi52MS5VcGRhdGVCZXRUeXBlc1Jlc3BvbnNlIgBCKFomZ2l0aHViLmNvbS9kdWNidC90dC1nby9nZW4vcHJvdG8vdjE7djFiBnByb3RvMw");

/**
 * Empty - uses username from JWT context
 *
 * @generated from message v1.ListBetTypesRequest
 */
export type ListBetTypesRequest = Message<"v1.ListBetTypesRequest"> & {
};

/**
 * Describes the message v1.ListBetTypesRequest.
 * Use `create(ListBetTypesRequestSchema)` to create a new message.
 */
export const ListBetTypesRequestSchema: GenMessage<ListBetTypesRequest> = /*@__PURE__*/
  messageDesc(file_v1_bet_type, 0);

/**
 * @generated from message v1.ListBetTypesResponse
 */
export type ListBetTypesResponse = Message<"v1.ListBetTypesResponse"> & {
  /**
   * @generated from field: repeated v1.BetType bet_types = 1;
   */
  betTypes: BetType[];
};

/**
 * Describes the message v1.ListBetTypesResponse.
 * Use `create(ListBetTypesResponseSchema)` to create a new message.
 */
export const ListBetTypesResponseSchema: GenMessage<ListBetTypesResponse> = /*@__PURE__*/
  messageDesc(file_v1_bet_type, 1);

/**
 * @generated from message v1.TypeList
 */
export type TypeList = Message<"v1.TypeList"> & {
  /**
   * @generated from field: repeated string types = 1;
   */
  types: string[];
};

/**
 * Describes the message v1.TypeList.
 * Use `create(TypeListSchema)` to create a new message.
 */
export const TypeListSchema: GenMessage<TypeList> = /*@__PURE__*/
  messageDesc(file_v1_bet_type, 2);

/**
 * @generated from message v1.UpdateBetTypesRequest
 */
export type UpdateBetTypesRequest = Message<"v1.UpdateBetTypesRequest"> & {
  /**
   * Map of bet_type_id to list of type strings
   * e.g., {11: ["xcddau", "xcdaodau", "tdd"], 12: ["dxcduoi", "dcxduoi"]}
   *
   * @generated from field: map<int32, v1.TypeList> data = 1;
   */
  data: { [key: number]: TypeList };
};

/**
 * Describes the message v1.UpdateBetTypesRequest.
 * Use `create(UpdateBetTypesRequestSchema)` to create a new message.
 */
export const UpdateBetTypesRequestSchema: GenMessage<UpdateBetTypesRequest> = /*@__PURE__*/
  messageDesc(file_v1_bet_type, 3);

/**
 * @generated from message v1.BetType
 */
export type BetType = Message<"v1.BetType"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 bet_type_id = 2;
   */
  betTypeId: number;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string username = 4;
   */
  username: string;
};

/**
 * Describes the message v1.BetType.
 * Use `create(BetTypeSchema)` to create a new message.
 */
export const BetTypeSchema: GenMessage<BetType> = /*@__PURE__*/
  messageDesc(file_v1_bet_type, 4);

/**
 * @generated from message v1.UpdateBetTypesResponse
 */
export type UpdateBetTypesResponse = Message<"v1.UpdateBetTypesResponse"> & {
  /**
   * @generated from field: repeated v1.BetType bet_types = 1;
   */
  betTypes: BetType[];

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message v1.UpdateBetTypesResponse.
 * Use `create(UpdateBetTypesResponseSchema)` to create a new message.
 */
export const UpdateBetTypesResponseSchema: GenMessage<UpdateBetTypesResponse> = /*@__PURE__*/
  messageDesc(file_v1_bet_type, 5);

/**
 * @generated from service v1.BetTypeService
 */
export const BetTypeService: GenService<{
  /**
   * @generated from rpc v1.BetTypeService.ListBetTypes
   */
  listBetTypes: {
    methodKind: "unary";
    input: typeof ListBetTypesRequestSchema;
    output: typeof ListBetTypesResponseSchema;
  },
  /**
   * @generated from rpc v1.BetTypeService.UpdateBetTypes
   */
  updateBetTypes: {
    methodKind: "unary";
    input: typeof UpdateBetTypesRequestSchema;
    output: typeof UpdateBetTypesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_bet_type, 0);

